import { ReactNode } from "react";
import { Box, Divider, Paper, Typography } from "@mui/material";

type OrderDetailCardProps = {
	title: string;
	children: ReactNode;
};

export function OrderDetailCard({ title, children }: OrderDetailCardProps) {
	return (
		<Paper variant="outlined" sx={{ p: 3, height: "100%" }}>
			<Typography variant="h6" sx={{ mb: 1 }}>
				{title}
			</Typography>
			<Divider sx={{ mb: 2 }} />
			<Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
				{children}
			</Box>
		</Paper>
	);
}

type OrderDetailFieldProps = {
	label: string;
	value: ReactNode;
};

export function OrderDetailField({ label, value }: OrderDetailFieldProps) {
	return (
		<Box>
			<Typography
				variant="caption"
				color="text.secondary"
				sx={{ display: "block" }}
			>
				{label}
			</Typography>
			<Typography variant="body2">{value}</Typography>
		</Box>
	);
}
